module.exports = __webpack_public_path__ + "img/pr-11.45322c0f.png";